import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import StateWarning from './StateWarning';
import Loading from "./loader";
import closeImage from "./images/close.png";
import AssignAdminsModal from './AssignAdminsModal';
import { EllipsisOutlined, InfoCircleOutlined, ArrowLeftOutlined, CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import { Tooltip, Dropdown, Menu, Modal, Select } from "antd";
import {enqueueSnackbar} from "notistack";

class VoteUserMeetings extends Component {
    // Статические маппинги статусов
    static STATUS_MAP = {
        1: 'Ожидается',
        2: 'Разрешена регистрация',
        3: 'Разрешено голосование',
        4: 'Голосование завершено',
        5: 'Собрание завершилось'
    };

    static REVERSE_STATUS_MAP = {
        'Ожидается': 1,
        'Разрешена регистрация': 2,
        'Разрешено голосование': 3,
        'Голосование завершено': 4,
        'Собрание завершилось': 5
    };

    state = {
        meetingsData: [],
        issuersData: [],
        currentPage: 1,
        pageSize: 10,
        loading: true,
        error: null,
        selectedIndex: null,
        selectedMeeting: null,
        searchQuery: '',
        filters: [],
        isStatusModalVisible: false,
        selectedStatus: null,
        meetingToChangeStatus: null,
        isAssignAdminModalVisible: false,
        selectedMeetingForAdmin: null,
        sortBy: 'meeting_date',
        sortDirection: 'desc',
        userName: ''
    };

    async componentDidMount() {
        const { is_superuser } = this.props;
        if (!is_superuser) {
            alert("Доступ запрещён");
            window.location.href = `/#/`;
            return;
        }

        const userId = this.props.match?.params?.userId;

        await this.loadMeetings(userId);
    }

    async componentDidUpdate(prevProps) {
        const { is_superuser } = this.props;

        if (prevProps.is_superuser !== is_superuser) {
            if (!is_superuser) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
            }
        }
    }

    getRenderKey() {
        const { currentPage, pageSize, sortBy, sortDirection, filters, searchQuery } = this.state;
        return `users-${currentPage}-${pageSize}-${sortBy}-${sortDirection}-${filters.length}-${searchQuery}`;
    }

    loadMeetings = async (userId) => {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        try {
            const response = await fetch(`${API_ADDRESS}get_user_meetings/?user_id=${userId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    meetingsData: data.meetings || [],
                    issuersData: data.issuers || [],
                    userName: data.user_name || '(ФИО отсутствует)',
                    loading: false,
                });
            } else {
                const errorData = await response.json();
                alert(errorData.detail || "Ошибка при загрузке собраний пользователя");
                this.setState({ loading: false });
            }
        } catch (e) {
            console.error("Ошибка при загрузке собраний:", e);
            this.setState({ error: "Произошла ошибка сети", loading: false });
        }
    };

    getPaginatedMeetings = () => {
        const { meetingsData, currentPage, pageSize, filters, searchQuery, sortBy, sortDirection } = this.state;

        // Фильтрация (оставляем как есть)
        let filteredMeetings = meetingsData.filter((item) => {
            const issuerName = this.getIssuerName(item.issuer).toLowerCase();
            const formattedDate = this.formatDate(item.meeting_date).toLowerCase();
            const queryParts = searchQuery.toLowerCase().split('.');
            const dateMatches = queryParts.every((part) => formattedDate.includes(part));
            return (
                item.meeting_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                dateMatches ||
                issuerName.includes(searchQuery.toLowerCase())
            );
        });

        if (filters.length > 0) {
            filteredMeetings = filteredMeetings.filter((item) =>
                filters.every((filter) => {
                    const issuerName = this.getIssuerName(item.issuer).toLowerCase();
                    const formattedDate = this.formatDate(item.meeting_date).toLowerCase();
                    const queryParts = filter.toLowerCase().split('.');
                    const dateMatches = queryParts.every((part) => formattedDate.includes(part));
                    return (
                        item.meeting_name.toLowerCase().includes(filter.toLowerCase()) ||
                        dateMatches ||
                        issuerName.includes(filter.toLowerCase())
                    );
                })
            );
        }

        // Сортировка
        const sortedMeetings = [...filteredMeetings].sort((a, b) => {
            const order = sortDirection === 'asc' ? 1 : -1; // asc = от старых к новым

            if (sortBy === 'meeting_date') {
                const dateA = new Date(a.meeting_date);
                const dateB = new Date(b.meeting_date);
                return (dateA - dateB) * order;
            }

            return 0;
        });

        // Пагинация
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return sortedMeetings.slice(startIndex, endIndex);
    };

    handleSort = (field) => {
        this.setState(
            (prevState) => {
                let newDirection = 'asc';
                let newSortBy = field;

                if (prevState.sortBy === field) {
                    newDirection = prevState.sortDirection === 'asc' ? 'desc' : 'asc';
                } else {
                    newDirection = 'asc';
                }

                return {
                    sortBy: newSortBy,
                    sortDirection: newDirection,
                    currentPage: 1,
                    selectedIndex: null,
                    selectedMeeting: null,
                };
            },
            this.getPaginatedMeetings
        );
    };

    getSortIndicator = (field) => {
        const { sortBy, sortDirection } = this.state;
        if (sortBy !== field) {
            return { activeAsc: false, activeDesc: false };
        }
        return {
            activeAsc: sortDirection === 'asc',
            activeDesc: sortDirection === 'desc'
        };
    };

    handleSearchChange = (e) => {
        const { value } = e.target;
        this.setState({ searchQuery: value });
        if (e.key === 'Enter' && value.trim() !== '') {
            this.setState((prevState) => ({
                filters: [...prevState.filters, value.trim()],
                searchQuery: '',
                currentPage: 1,
                selectedIndex: null,
                selectedUser: null,
            }));
        }
    };

    removeFilter = (filterToRemove) => {
        this.setState((prevState) => ({
            filters: prevState.filters.filter((filter) => filter !== filterToRemove),
            currentPage: 1,
            selectedIndex: null,
            selectedUser: null,
        }));
    };

    selectItem = (index) => {
        const { selectedIndex, meetingsData } = this.state;
        const paginatedMeetings = this.getPaginatedMeetings();

        if (selectedIndex === index) {
            this.setState({ selectedIndex: null, selectedMeeting: null });
        } else {
            this.setState({ selectedIndex: index }, () => {
                setTimeout(() => {
                    const row = document.querySelector(`.adm-table tbody tr:nth-child(${index + 1})`);
                    const wrapper = document.querySelector('.table-wrapper');

                    if (row && wrapper) {
                        const rowRect = row.getBoundingClientRect();
                        const wrapperRect = wrapper.getBoundingClientRect();
                        const top = rowRect.top - wrapperRect.top + rowRect.height / 2;

                        this.setState({
                            selectedMeeting: {
                                paginatedMeetings: [index],
                                rowTop: top,
                                index: index,
                            },
                        });
                    }
                }, 0);
            });
        }
    };

    getIssuerName(issuerId) {
        const { issuersData } = this.state;
        if (!issuersData) return "Нет данных об эмитенте";

        const issuer = issuersData.find(issuer => issuer.issuer_id === issuerId);
        return issuer ? issuer.full_name : "Эмитент не найден";
    }

    formatDate(dateString) {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString('ru-RU', options).replace(/\//g, '.');
    }

    handleBackClick = () => {
        window.location.href = `/#/voteAllUsers/`;
    };

    handleRegMeeting = () => {
        const { selectedIndex } = this.state;
        const paginatedMeetings = this.getPaginatedMeetings();
        const meetingId = paginatedMeetings[selectedIndex]?.meeting_id;
        if (meetingId) {
            window.location.href = `/#/voteRegUsers/${meetingId}/`;
        }
    };

    handleUpdateMeeting = () => {
        const { selectedIndex } = this.state;
        const paginatedMeetings = this.getPaginatedMeetings();
        const meetingId = paginatedMeetings[selectedIndex]?.meeting_id;
        if (meetingId) {
            window.location.href = `/#/voteMeetingRedact/${meetingId}/`;
        }
    };

    handleUsersMeeting = () => {
        const { selectedIndex } = this.state;
        const paginatedMeetings = this.getPaginatedMeetings();
        const meetingId = paginatedMeetings[selectedIndex]?.meeting_id;
        if (meetingId) {
            window.location.href = `/#/voteUsers/${meetingId}/`;
        }
    };

    openStatusModal = (index) => {
        const paginatedMeetings = this.getPaginatedMeetings();
        const meeting = paginatedMeetings[index];
        const statusText = VoteUserMeetings.STATUS_MAP[meeting.status] || 'Неизвестно';

        this.setState({
            isStatusModalVisible: true,
            selectedStatus: statusText,
            meetingToChangeStatus: meeting,
        });
    };

    closeStatusModal = () => {
        this.setState({
            isStatusModalVisible: false,
            selectedStatus: null,
            meetingToChangeStatus: null,
        });
    };

    handleUpdateStatus = () => {
        const { meetingToChangeStatus, selectedStatus } = this.state;
        const meetingId = meetingToChangeStatus?.meeting_id;
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

        if (!meetingId || !selectedStatus) {
            enqueueSnackbar('Ошибка: не удалось определить данные для обновления', { variant: 'error' });
            return;
        }

        fetch(`${API_ADDRESS}update_status_meeting/${meetingId}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({ status: selectedStatus }),
        })
        .then(async (response) => {
            if (response.ok) {
                const result = await response.json();

                // Обновляем статус в списке собраний
                this.setState(prevState => ({
                    meetingsData: prevState.meetingsData.map(meeting =>
                        meeting.meeting_id === meetingId
                            ? { ...meeting, status: result.status }
                            : meeting
                    ),
                    isStatusModalVisible: false,
                    selectedStatus: null,
                    meetingToChangeStatus: null,
                }));

                enqueueSnackbar('Статус собрания успешно обновлён', { variant: 'success' });
            } else {
                const error = await response.json();
                enqueueSnackbar('Не удалось обновить статус', { variant: 'error' });
            }
        })
        .catch(() => {
            enqueueSnackbar('Произошла сетевая ошибка', { variant: 'error' });
        });
    };

    renderFilters() {
        const { filters } = this.state;
        return (
            <div className="filters-container">
                {filters.map((filter, index) => (
                    <div key={index} className="filter-tag">
                        {filter}
                        <img
                            src={closeImage}
                            alt="Удалить"
                            style={{
                                cursor: 'pointer',
                                width: '15px',
                                height: '15px'
                            }}
                            onClick={() => this.removeFilter(filter)}
                        />
                    </div>
                ))}
            </div>
        );
    }

    // --- Открытие модального окна назначения администраторов ---
    openAssignAdminModal = (index) => {
        const paginatedMeetings = this.getPaginatedMeetings();
        const meeting = paginatedMeetings[index];
        this.setState({
            isAssignAdminModalVisible: true,
            selectedMeetingForAdmin: meeting,
        });
    };

    closeAssignAdminModal = () => {
        this.setState({
            isAssignAdminModalVisible: false,
            selectedMeetingForAdmin: null,
        });
    };

    handleAssignAdminSuccess = () => {
        this.loadMeetings();
    };

    // --- Метод пагинации ---
    renderPagination = (totalPages) => {
        const { currentPage } = this.state;
        const groupSize = 10;
        const currentGroup = Math.ceil(currentPage / groupSize);
        const startPage = (currentGroup - 1) * groupSize + 1;
        const endPage = Math.min(currentGroup * groupSize, totalPages);

        const goToPage = (page) => {
            if (page >= 1 && page <= totalPages) {
                this.setState({
                    currentPage: page,
                    selectedIndex: null,
                    selectedUser: null,
                });
            }
        };

        const goToPrevGroup = () => {
            const prevStart = startPage - groupSize;
            const newPage = prevStart >= 1 ? prevStart : 1;
            this.setState({
                currentPage: newPage,
                selectedIndex: null,
                selectedUser: null,
            });
        };

        const goToNextGroup = () => {
            const nextStart = startPage + groupSize;
            if (nextStart <= totalPages) {
                this.setState({
                    currentPage: nextStart,
                    selectedIndex: null,
                    selectedUser: null,
                });
            }
        };

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '100%' }}>
                {/* Первая строка — номера страниц */}
                <div className="pagination-pages-row" style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'center' }}>
                    {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
                        const page = startPage + i;
                        return (
                            <button5
                                key={page}
                                className={`pagination-button ${currentPage === page ? 'active' : ''}`}
                                onClick={() => goToPage(page)}
                            >
                                {page}
                            </button5>
                        );
                    })}
                </div>

                {/* Вторая строка — стрелки перелистывания */}
                {(currentGroup > 1 || currentGroup * groupSize < totalPages) && (
                    <div className="pagination-arrows-row" style={{ display: 'flex', gap: '6px', marginTop: '8px' }}>
                        {currentGroup > 1 && (
                            <button5
                                className="pagination-button"
                                onClick={goToPrevGroup}
                                style={{ fontWeight: 'bold' }}
                            >
                                <CaretLeftOutlined style={{ fontSize: '9px' }} />
                            </button5>
                        )}
                        {currentGroup * groupSize < totalPages && (
                            <button5
                                className="pagination-button"
                                onClick={goToNextGroup}
                                style={{ fontWeight: 'bold' }}
                            >
                                <CaretRightOutlined style={{ fontSize: '9px' }} />
                            </button5>
                        )}
                    </div>
                )}
            </div>
        );
    };

    render() {
        const {
            meetingsData,
            issuersData,
            loading,
            error,
            selectedIndex,
            searchQuery,
            currentPage,
            pageSize,
            filters,
            isStatusModalVisible,
            selectedStatus,
        } = this.state;

        if (loading) {
            return <div><Loading /></div>;
        }

        if (error) {
            return <div>{error}</div>;
        }

        // Фильтрация и пагинация
        const paginatedMeetings = this.getPaginatedMeetings();

        // Подсчёт общего количества отфильтрованных элементов
        const totalFiltered = (() => {
            let filtered = meetingsData.filter((item) => {
                const issuerName = this.getIssuerName(item.issuer).toLowerCase();
                const formattedDate = this.formatDate(item.meeting_date).toLowerCase();
                const queryParts = searchQuery.toLowerCase().split('.');
                const dateMatches = queryParts.every((part) => formattedDate.includes(part));
                return (
                    item.meeting_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    dateMatches ||
                    issuerName.includes(searchQuery.toLowerCase())
                );
            });

            if (filters.length > 0) {
                filtered = filtered.filter((item) =>
                    filters.every((filter) => {
                        const issuerName = this.getIssuerName(item.issuer).toLowerCase();
                        const formattedDate = this.formatDate(item.meeting_date).toLowerCase();
                        const queryParts = filter.toLowerCase().split('.');
                        const dateMatches = queryParts.every((part) => formattedDate.includes(part));
                        return (
                            item.meeting_name.toLowerCase().includes(filter.toLowerCase()) ||
                            dateMatches ||
                            issuerName.includes(filter.toLowerCase())
                        );
                    })
                );
            }
            return filtered.length;
        })();
        const totalPages = Math.ceil(totalFiltered / pageSize);

        // Контекстное меню
        const meetingActionMenu = (index) => {
            const paginatedMeetings = this.getPaginatedMeetings();
            const meeting = paginatedMeetings[index];
            const statusText = VoteUserMeetings.STATUS_MAP[meeting?.status] || 'Неизвестно';

            return (
                <Menu>
                    <Menu.Item
                        key="users"
                        onClick={() => {
                            this.setState({ selectedIndex: index }, () => {
                                this.handleUsersMeeting();
                            });
                        }}
                    >
                        Участники
                    </Menu.Item>
                    <Menu.Item
                        key="edit"
                        onClick={() => {
                            this.setState({ selectedIndex: index }, () => {
                                this.handleUpdateMeeting();
                            });
                        }}
                    >
                        Редактировать
                    </Menu.Item>
                    <Menu.Item
                        key="reg"
                        onClick={() => {
                            this.setState({ selectedIndex: index }, () => {
                                this.handleRegMeeting();
                            });
                        }}
                    >
                        Зарег. лица
                    </Menu.Item>
                    <Menu.Divider />
                    {this.props.is_superuser && (
                        <Menu.Item
                            key="assign_admin"
                            onClick={() => this.openAssignAdminModal(index)}
                        >
                            Назначить администратора
                        </Menu.Item>
                    )}
                    <Menu.Item
                        key="status"
                        onClick={() => this.openStatusModal(index)}
                    >
                        Статус собрания: <b>{statusText}</b>
                    </Menu.Item>
                </Menu>
            );
        };

        return (
            <div className="page-container">
                <div>
                    <div className="header-container">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                            <div className="back-button-wrapper" onClick={this.handleBackClick}>
                                <ArrowLeftOutlined
                                    style={{ fontSize: '20px', cursor: 'pointer', marginTop: '4px' }}
                                />
                            </div>
                            <h1>Собрания</h1>
                        </div>
                    </div>

                    {/* Строка поиска */}
                    {meetingsData && meetingsData.length > 0 && (
                        <div className="search-input">
                            <input
                                type="text"
                                placeholder="Поиск..."
                                value={this.state.searchQuery}
                                onChange={this.handleSearchChange}
                                onKeyDown={this.handleSearchChange}
                                className="main-input4 default-text-style"
                            />
                            <Tooltip
                                title="В строке можно использовать последовательную фильтрацию по разным условиям. Нажмите Enter после ввода данных для создания одного условия"
                                placement="right"
                            >
                                <InfoCircleOutlined style={{ fontSize: '18px', color: '#000', cursor: 'pointer' }} />
                            </Tooltip>
                        </div>
                    )}

                    {/* Теги фильтров */}
                    <div className="search-tags">
                        {this.renderFilters()}
                    </div>

                    {/* Основной контент: имя + таблица или предупреждения */}
                    {(!meetingsData || meetingsData.length === 0) ? (
                        <StateWarning message={`Собрания для пользователя (${this.state.userName}) не назначены`} />
                    ) : (
                        <>
                            <div className="username-container">
                                {this.state.userName && (
                                    <>
                                        <b>Пользователь:</b>{' '}
                                        <span className="username-badge">
                                            {this.state.userName}
                                        </span>
                                    </>
                                )}
                            </div>

                            {paginatedMeetings.length === 0 ? (
                                <StateWarning message="Собрания не найдены" />
                            ) : (
                                <div className="table-wrapper">
                                    <div
                                        key={this.getRenderKey()}
                                        className="table-animated-container"
                                        style={{
                                            opacity: 0,
                                            animation: 'fadeIn 0.3s ease-in-out forwards'
                                        }}
                                    >
                                        <div className="table-adm-container">
                                            <table className="adm-table">
                                                <thead>
                                                    <tr>
                                                        <th>№</th>
                                                        <th
                                                            onClick={() => this.handleSort('meeting_date')}
                                                            style={{ cursor: 'pointer', position: 'relative', whiteSpace: 'normal' }}
                                                        >
                                                            Дата собрания
                                                            <span style={{ marginLeft: '8px', fontSize: '14px', marginTop: '-10px' }}>
                                                                <span
                                                                    style={{
                                                                        color: this.getSortIndicator('meeting_date').activeAsc ? '#007bff' : '#666',
                                                                        fontWeight: 'bold'
                                                                    }}
                                                                >
                                                                    ↑
                                                                </span>
                                                                <span
                                                                    style={{
                                                                        color: this.getSortIndicator('meeting_date').activeDesc ? '#007bff' : '#666',
                                                                        fontWeight: 'bold',
                                                                        marginLeft: '1px'
                                                                    }}
                                                                >
                                                                    ↓
                                                                </span>
                                                            </span>
                                                        </th>
                                                        <th>Имя эмитента</th>
                                                        <th>Название собрания</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paginatedMeetings.map((item, index) => {
                                                        const globalIndex = (currentPage - 1) * pageSize + index + 1;
                                                        const isSelected = selectedIndex === index;
                                                        return (
                                                            <tr
                                                                key={index}
                                                                className={isSelected ? 'selected' : ''}
                                                                onClick={() => this.selectItem(index)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <td>{globalIndex}</td>
                                                                <td>{this.formatDate(item.meeting_date)}</td>
                                                                <td>{this.getIssuerName(item.issuer)}</td>
                                                                <td>{item.meeting_name}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>

                                            {/* Пагинация */}
                                            <div className="pagination-container">
                                                {totalPages > 1 && this.renderPagination(totalPages)}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Контекстная кнопка */}
                                    {this.state.selectedMeeting && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                left: 'calc(50% + 25% + 10px)',
                                                top: this.state.selectedMeeting.rowTop,
                                                transform: 'translateY(-50%)',
                                                zIndex: 10,
                                                backgroundColor: 'white',
                                                padding: '5px 8px',
                                                border: '1px solid #000',
                                                borderRadius: '4px',
                                                boxShadow: '0 0 5px rgba(0,0,0,0.1)',
                                            }}
                                        >
                                            <Dropdown overlay={meetingActionMenu(this.state.selectedMeeting.index)} trigger={['click']}>
                                                <EllipsisOutlined
                                                    style={{
                                                        fontSize: '18px',
                                                        cursor: 'pointer',
                                                        color: '#1890ff',
                                                    }}
                                                />
                                            </Dropdown>
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}

                    {/* Модальное окно для изменения статуса */}
                    {isStatusModalVisible && (
                        <Modal
                            title="Изменение статуса собрания"
                            open={isStatusModalVisible}
                            onOk={this.handleUpdateStatus}
                            onCancel={this.closeStatusModal}
                            okText="Ок"
                            cancelText="Отмена"
                        >
                            <div style={{ marginBottom: '16px' }}>
                                <label>Выберите статус:</label>
                                <Select
                                    value={selectedStatus}
                                    onChange={(value) => this.setState({ selectedStatus: value })}
                                    style={{ width: '100%', marginTop: '8px' }}
                                    placeholder="Выберите статус"
                                    options={Object.values(VoteUserMeetings.REVERSE_STATUS_MAP).map(statusNum => {
                                        const statusText = VoteUserMeetings.STATUS_MAP[statusNum];
                                        return {
                                            value: statusText,
                                            label: statusText,
                                        };
                                    })}
                                />
                            </div>
                        </Modal>
                    )}

                    {/* Модальное окно назначения администраторов */}
                    {this.state.isAssignAdminModalVisible && this.state.selectedMeetingForAdmin && (
                        <AssignAdminsModal
                            visible={true}
                            onClose={this.closeAssignAdminModal}
                            meetingId={this.state.selectedMeetingForAdmin.meeting_id}
                            onAssignSuccess={this.handleAssignAdminSuccess}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(VoteUserMeetings);